import React, { useState } from 'react'

const GuestCounter = ({ title, options, selectedValue, onChange }) => {
  return (
    <div className='col-lg-6 col-md-6'>
      <h6>{title}</h6>
      <ul className='guestCounter gbCounter'>
        {options.map(option => (
          <li
            key={option}
            className={selectedValue === option ? 'selected' : ''}
            value={option}
            onClick={() => onChange(option)}
          >
            {option}
          </li>
        ))}
      </ul>
    </div>
  )
}

const TravelClassSelector = ({ selectedClass, onChange }) => {
  const classes = ['Economy', 'Premium Economy', 'Business', 'First Class']

  return (
    <div className='col-lg-10 col-md-10 col-12'>
      <h6>CHOOSE TRAVEL CLASS</h6>
      <ul className='guestCounter gbCounter Business'>
        {classes.map(travelClass => (
          <li
            key={travelClass}
            className={selectedClass === travelClass ? 'selected' : ''}
            onClick={() => onChange(travelClass)}
          >
            {travelClass}
          </li>
        ))}
      </ul>
    </div>
  )
}

const TravelerBox = ({
  formData,
  setFormData,
  guestCounterOpen,
  setGuestCounterOpen
}) => {
  const [error, setError] = useState('')

  const handleChange = (key, value) => {
    setFormData(prev => ({ ...prev, [key]: value }))
  }

  const validateForm = () => {
    const { adults = 0, children = 0, infants = 0, travelClass } = formData
    const totalTravelers = adults + children + infants

    if (totalTravelers < 1) {
      return 'At least one traveler is required.'
    }

    if (!travelClass) {
      return 'Please select a travel class.'
    }

    return ''
  }

  const handleApply = () => {
    const validationError = validateForm()
    if (validationError) {
      setError(validationError)
    } else {
      setError('')
      setGuestCounterOpen(false)
    }
  }

  const optionsConfig = {
    adults: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    children: [0, 1, 2, 3, 4, 5, 6],
    infants: [0, 1, 2, 3, 4, 5, 6]
  }

  return (
    <div
      className='travelerBox'
      style={{ display: guestCounterOpen ? 'block' : 'none' }}
    >
      <div className='row'>
        <div className='col-lg-12 col-md-12 col-12'>
          <GuestCounter
            title='Adult (12y +)'
            options={optionsConfig.adults}
            selectedValue={formData.adults}
            onChange={value => handleChange('adults', value)}
          />
        </div>
      </div>

      <div className='row'>
        <GuestCounter
          title='Child	 (2y - 12y)'
          options={optionsConfig.children}
          selectedValue={formData.children}
          onChange={value => handleChange('children', value)}
        />
        <GuestCounter
          title='Infant (below 2y)'
          options={optionsConfig.infants}
          selectedValue={formData.infants}
          onChange={value => handleChange('infants', value)}
        />
      </div>

      <div className='row'>
        <TravelClassSelector
          selectedClass={formData.travelClass}
          onChange={value => handleChange('travelClass', value)}
        />
        <div className='col-lg-2 col-md-2 col-12 mt-3'>
          <div className='d-flex justify-content-end'>
            <div onClick={handleApply} className='btn btn-apply'>
              APPLY
            </div>
          </div>
        </div>
      </div>

      {error && <div className='error-message'>{error}</div>}
    </div>
  )
}

export default TravelerBox
